module.exports = __webpack_public_path__ + "img/vipzs.e5583519.png";